import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Utils from 'helpers/utils.js';
import { Button, PageHero, PageLoader, Section } from '@kambria/kambria-lego';
import { getLicenseByUser, getDAOList } from 'redux/actions/codeBase2/codeBase2.action';
import Web3 from 'web3';
import { ERC20_ABI, LP_ABI, DAO_ABI, ServiceRevenueSharingABI } from './abis';
import { Container, Row, Col } from 'reactstrap';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './style.css';

import enums from 'helpers/const';
import defaultImage from 'static/images/hero-banner-2022.png';
import background from 'static/images/bounty-header.png';
const formatValue = (value) => {
  return typeof value === 'number' ? value.toFixed(4) : value;
};
const getNativeTokenName = (chainId) => {
  return nativeTokenNames[chainId] || 'Native Token';
};

const nativeCurrencyDecimals = {
  1: 6, // Ether
  56: 18, // BNB
  137: 18, // MATIC
  7001: 18, // Zeta Testnet
  // Thêm chainId khác nếu cần
};
const nativeTokenNames = {
  1: 'ETH', // Ethereum Mainnet
  56: 'BNB', // Binance Smart Chain Mainnet
  137: 'MATIC', // Polygon Mainnet
  7001: 'ZETA', // Zeta Testnet
  // Thêm các chainId khác nếu cần
};

class DaoInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listLicenses: [],
      allDaos: [],
      userWalletID: '', // Initialize userWalletID in the state
      metamaskStatus: false,
    };
  }

  style = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  };

  // Assuming this is a class component
  componentDidMount() {
    this._isMounted = true; // Track mounted state

    const fetchData = async () => {
      try {
        const { getLicenseByUser, getDAOList } = this.props;
        const [licenseUsers, allDaos] = await Promise.all([getLicenseByUser(), getDAOList()]);

        if (this._isMounted) {
          // Only update state if component is still mounted
          this.setState({
            listLicenses: licenseUsers.data,
            allDaos: allDaos.data,
          });
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle errors as needed
      }
    };

    fetchData();
  }

  componentWillUnmount() {
    this._isMounted = false; // Ensure we don't try to set state after unmount
  }

  connectMetamaskForBalance = async () => {
    let account = null;
    if (typeof window.ethereum !== 'undefined') {
      try {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        this.setState({ userWalletID: accounts[0], metamaskStatus: !!accounts[0] });
        account = accounts[0];
        // Listen for account changes
        window.ethereum.on('accountsChanged', (accounts) => {
          // Use arrow function to maintain 'this' context
          this.setState({ userWalletID: accounts[0] });
        });
      } catch (error) {
        console.error('Error connecting to MetaMask:', error);
      }
    } else {
      alert('Please install MetaMask to use this feature');
    }
    return account;
  };

  claimServiceRevenueAction = async (chainId, ServiceRevenueSharingAddress, account) => {
    let web3 = null;
    web3 = new Web3(window.ethereum);

    if (ServiceRevenueSharingAddress) {
      const ServiceRevenueSharingContract = new web3.eth.Contract(
        ServiceRevenueSharingABI,
        ServiceRevenueSharingAddress,
      );

      try {
        // Lấy giá gas hiện tại từ mạng
        let gasPrice = await web3.eth.getGasPrice();
        // Tăng giá gas lên 10% để làm cho nó "aggressive"
        let aggressiveGasPrice = Math.floor(gasPrice * 1.1);

        let result = await ServiceRevenueSharingContract.methods.claim().send({
          from: account,
          gas: 3000000, // Đặt giới hạn gas cao hơn nếu cần
          gasPrice: aggressiveGasPrice, // Sử dụng giá gas đã tăng lên
        }); // console.log("result", result);
      } catch (error) {
        // Xử lý lỗi nếu cần thiết
        console.log(error);

        return [];
      }
      // Sau khi lấy xong thì có thể thực hiện các bước khác tại đây
    }
  };
  claimServiceRevenue = async (chainId, serviceRevenueSharingAddress) => {
    const account = await this.connectMetamaskForBalance();
    let isValid = true;
    let web3 = null;
    if (account && typeof window.ethereum !== 'undefined') {
      if (window.ethereum) {
        web3 = new Web3(window.ethereum);
      } else {
        console.error('Ethereum object not found, make sure you have a web3 provider.');
        return false;
      }
      const networkId = await web3.eth.net.getId();
      if (parseFloat(networkId) === parseFloat(chainId)) {
        this.setState({ chainId: chainId });
        await this.claimServiceRevenueAction(chainId, serviceRevenueSharingAddress, this.state.userWalletID);
      } else {
        alert('Wrong network. Please change your wallet network to Chain ID ' + chainId);
        window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: web3.utils.toHex(chainId) }],
        });
        isValid = false;
      }
    }
    return isValid;
  };
  loadDAOInfoAction = async (chainId, daoInfo, account) => {
    let web3 = null;
    web3 = new Web3(window.ethereum);

    if (daoInfo.serviceRevenueSharingAddress) {
      // console.log("ProcessorAddress", ServiceRevenueSharingAddress)

      const ServiceRevenueSharingContract = new web3.eth.Contract(
        ServiceRevenueSharingABI,
        daoInfo.serviceRevenueSharingAddress,
      );
      // console.log('daoInfo', daoInfo);
      const DaoContract = new web3.eth.Contract(DAO_ABI, daoInfo.gtTokenAddress);
      const LPContract = new web3.eth.Contract(LP_ABI, daoInfo.lpTokenAddress);
      // console.log("CodebaseLicensingProcessorContract", ServiceRevenueSharingContract)

      try {
        this.setState({
          USDTBalanceInEther: 'loading ...',
          KATBalanceInEther: 'loading ...',
          PAXGImplementerBalanceInEther: 'loading ...',
          NativeBalanceInEther: 'loading ...',
        });
        this.setState({
          TotalDAOServiceRevenueForTheMonth: 'loading ...',
          TotalServiceRevenueDistributedToAllDAOMembers: 'loading ...',
          NumberOfLPTokensYouHold: 'loading ...',
          lPTotalSupply: 'loading ...',
        });
        this.setState({
          withdrawableUSDT: 'loading ...',
          withdrawableKAT: 'loading ...',
          withdrawableinPAXG: 'loading ...',
          withdrawableinNative: 'loading ...',
        });
        let lpBalance = 'loading ...';
        let lPTotalSupply = 'loading ...';
        let lpDecimals = 'loading ...';
        let calculations = 'loading ...';
        let totalLPShareOn1stTokenWei = 'loading ...';
        let totalRevenueIn1stTokenWei = 'loading ...';
        let totalSharesIn1stTokenWei = 'loading ...';
        let USDTAddress = 'loading ...';
        let KATAddress = 'loading ...';
        let PAXGImplementerAddress = 'loading ...';
        let NativeAddress = 'loading ...';
        let USDTDecimals = 'loading ...';
        let KATDecimals = 'loading ...';
        let PAXGImplementerDecimals = 'loading ...';
        let NativeDecimals = 'loading ...';
        let USDTBalance = 'loading ...';
        let KATBalance = 'loading ...';
        let PAXGImplementerBalance = 'loading ...';
        let NativeBalance = 'loading ...';
        let USDTBalanceInEther = 'loading ...';
        let KATBalanceInEther = 'loading ...';
        let PAXGImplementerBalanceInEther = 'loading ...';
        let NativeBalanceInEther = 'loading ...';
        let finalCalculation = 'loading ...';
        let USDTContract = 'loading ...';
        let KATContract = 'loading ...';
        let PAXGImplementerContract = 'loading ...';
        let withdrawableUSDT = 'loading ...';
        let withdrawableKAT = 'loading ...';
        let withdrawableinPAXG = 'loading ...';
        let withdrawableinNative = 'loading ...';

        try {
          lpBalance = await LPContract.methods.balanceOf(account).call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          lpBalance = 'loading failed';
          console.error(error);
        }
        try {
          lPTotalSupply = await LPContract.methods.totalSupply().call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          lPTotalSupply = 'loading failed';
          console.error(error);
        }

        try {
          lpDecimals = await LPContract.methods.decimals().call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          lpDecimals = 'loading failed';
          console.error(error);
        }
        try {
          calculations = await ServiceRevenueSharingContract.methods
            .viewAllrevenueCalculations()
            .call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          calculations = 'loading failed';
          console.error(error);
        }
        try {
          finalCalculation = calculations[calculations.length - 1];
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          finalCalculation = 'loading failed';
          console.error(error);
        }

        // Lấy các giá trị cần thiết từ tính toán cuối cùng
        try {
          totalLPShareOn1stTokenWei = finalCalculation.totalLPShareOn1stTokenWei;
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          totalLPShareOn1stTokenWei = 'loading failed';
          console.error(error);
        }
        try {
          totalRevenueIn1stTokenWei = finalCalculation.totalRevenueIn1stTokenWei;
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          totalRevenueIn1stTokenWei = 'loading failed';
          console.error(error);
        }
        try {
          totalSharesIn1stTokenWei = finalCalculation.totalSharesIn1stTokenWei;
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          totalSharesIn1stTokenWei = 'loading failed';
          console.error(error);
        }
        try {
          USDTAddress = await ServiceRevenueSharingContract.methods.currencyAddresses(0).call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          USDTAddress = 'loading failed';
          console.error(error);
        }
        try {
          KATAddress = await ServiceRevenueSharingContract.methods.currencyAddresses(1).call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          KATAddress = 'loading failed';
          console.error(error);
        }
        try {
          PAXGImplementerAddress = await ServiceRevenueSharingContract.methods
            .currencyAddresses(2)
            .call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          PAXGImplementerAddress = 'loading failed';
          console.error(error);
        }
        try {
          NativeAddress = await ServiceRevenueSharingContract.methods.currencyAddresses(3).call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          NativeAddress = 'loading failed';
          console.error(error);
        }
        try {
          USDTContract = new web3.eth.Contract(ERC20_ABI, USDTAddress);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          USDTContract = 'loading failed';
          console.error(error);
        }
        try {
          KATContract = new web3.eth.Contract(ERC20_ABI, KATAddress);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          KATContract = 'loading failed';
          console.error(error);
        }
        try {
          PAXGImplementerContract = new web3.eth.Contract(ERC20_ABI, PAXGImplementerAddress);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          PAXGImplementerContract = 'loading failed';
          console.error(error);
        }

        try {
          USDTDecimals = await USDTContract.methods.decimals().call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          USDTDecimals = 'loading failed';
          console.error(error);
        }
        try {
          KATDecimals = await KATContract.methods.decimals().call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          KATDecimals = 'loading failed';
          console.error(error);
        }
        try {
          PAXGImplementerDecimals = await PAXGImplementerContract.methods.decimals().call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          PAXGImplementerDecimals = 'loading failed';
          console.error(error);
        }
        try {
          NativeDecimals = nativeCurrencyDecimals[chainId] || 18;
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          NativeDecimals = 'loading failed';
          console.error(error);
        }
        try {
          USDTBalance = await USDTContract.methods.balanceOf(daoInfo.gtTokenAddress).call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          USDTBalance = 'loading failed';
          console.error(error);
        }
        try {
          KATBalance = await KATContract.methods.balanceOf(daoInfo.gtTokenAddress).call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          KATBalance = 'loading failed';
          console.error(error);
        }
        try {
          PAXGImplementerBalance = await PAXGImplementerContract.methods
            .balanceOf(daoInfo.gtTokenAddress)
            .call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          PAXGImplementerBalance = 'loading failed';
          console.error(error);
        }
        try {
          NativeBalance = await web3.eth.getBalance(daoInfo.gtTokenAddress);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          NativeBalance = 'loading failed';
          console.error(error);
        }
        try {
          USDTBalanceInEther = USDTBalance / Math.pow(10, USDTDecimals);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          USDTBalanceInEther = 'loading failed';
          console.error(error);
        }
        try {
          KATBalanceInEther = KATBalance / Math.pow(10, KATDecimals);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          KATBalanceInEther = 'loading failed';
          console.error(error);
        }
        try {
          PAXGImplementerBalanceInEther = PAXGImplementerBalance / Math.pow(10, PAXGImplementerDecimals);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          PAXGImplementerBalanceInEther = 'loading failed';
          console.error(error);
        }
        try {
          NativeBalanceInEther = NativeBalance / Math.pow(10, NativeDecimals);
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          NativeBalanceInEther = 'loading failed';
          console.error(error);
        }

        this.setState({
          USDTBalanceInEther,
          KATBalanceInEther,
          PAXGImplementerBalanceInEther,
          NativeBalanceInEther,
        });
        this.setState({
          TotalDAOServiceRevenueForTheMonth: totalRevenueIn1stTokenWei / Math.pow(10, USDTDecimals),
          TotalServiceRevenueDistributedToAllDAOMembers: totalLPShareOn1stTokenWei / Math.pow(10, USDTDecimals),
          NumberOfLPTokensYouHold: lpBalance / Math.pow(10, lpDecimals),
          lPTotalSupply: lPTotalSupply / Math.pow(10, lpDecimals),
        });

        try {
          withdrawableUSDT = await ServiceRevenueSharingContract.methods
            .claimerList(account, USDTAddress)
            .call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          withdrawableUSDT = 'loading failed';
          console.error(error);
        }
        try {
          withdrawableKAT = await ServiceRevenueSharingContract.methods.claimerList(account, KATAddress).call({
            from: account,
          });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          withdrawableKAT = 'loading failed';
          console.error(error);
        }
        try {
          withdrawableinPAXG = await ServiceRevenueSharingContract.methods
            .claimerList(account, PAXGImplementerAddress)
            .call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          withdrawableinPAXG = 'loading failed';
          console.error(error);
        }
        try {
          withdrawableinNative = await ServiceRevenueSharingContract.methods
            .claimerList(account, NativeAddress)
            .call({ from: account });
        } catch (error) {
          // Xử lý lỗi nếu cần thiết
          withdrawableinNative = 'loading failed';
          console.error(error);
        }

        this.setState({
          withdrawableUSDT: withdrawableUSDT.withdrawableAmount / Math.pow(10, USDTDecimals),
          withdrawableKAT: withdrawableKAT.withdrawableAmount / Math.pow(10, KATDecimals),
          withdrawableinPAXG: withdrawableinPAXG.withdrawableAmount / Math.pow(10, PAXGImplementerDecimals),
          withdrawableinNative: withdrawableinNative.withdrawableAmount / Math.pow(10, NativeDecimals),
        });
      } catch (error) {
        // Xử lý lỗi nếu cần thiết
        console.error(error);

        return [];
      }
      // Sau khi lấy xong thì có thể thực hiện các bước khác tại đây
    }
  };
  loadDAOInfo = async (chainId, daoInfo) => {
    const account = await this.connectMetamaskForBalance();
    let isValid = true;
    let web3 = null;
    if (account && typeof window.ethereum !== 'undefined') {
      if (window.ethereum) {
        web3 = new Web3(window.ethereum);
      } else {
        console.error('Ethereum object not found, make sure you have a web3 provider.');
        return false;
      }
      const networkId = await web3.eth.net.getId();
      if (parseFloat(networkId) === parseFloat(chainId)) {
        await this.loadDAOInfoAction(chainId, daoInfo, this.state.userWalletID);
      } else {
        alert('Wrong network. Please change your wallet network to Chain ID ' + chainId);
        window.ethereum.request({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: web3.utils.toHex(chainId) }],
        });
        isValid = false;
      }
    }
    return isValid;
  };

  handleCardClick = (daoId) => {
    return `/dao/${daoId}`;
  };

  render() {
    const { allDaos } = this.state;

    const activeDaos = allDaos.filter((dao) => dao.status === 'Active' && dao.isDisplayed === true);

    return (
      <div id="site_wrapper">
        <div className="site-upper" style={this.style}>
          {this.props.header}
          <PageHero headline="Kambria DAOs" description="Participate in DAO governance and earn rewards" />
        </div>
        <main className="main bounty-home">
          <div id="content" className="bounty-content container">
            <PageLoader loading={!activeDaos.length} />

            {!!activeDaos.length && (
              <Section title="Active DAOs" className="card-section">
                <div className="row">
                  {activeDaos.map((dao, index) => (
                    <Col key={index} lg="4" md="6" sm="12" className="mb-4">
                      <Link to={this.handleCardClick(dao._id)} style={{ textDecoration: 'none' }}>
                        <Card
                          sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            backgroundColor: '#2A2E33',
                            borderRadius: '8px',
                            overflow: 'hidden',
                            cursor: 'pointer',
                          }}
                        >
                          <Box
                            sx={{
                              position: 'relative',
                              paddingTop: '75%',
                              backgroundColor: '#373C43',
                            }}
                          >
                            <Box
                              sx={{
                                position: 'absolute',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundImage: `url(${defaultImage})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                              }}
                            />
                          </Box>
                          <CardContent
                            sx={{
                              flexGrow: 1,
                              padding: '16px 24px',
                            }}
                          >
                            <Typography
                              sx={{
                                color: '#FFFFFF',
                                fontSize: '20px',
                                fontFamily: 'Questrial, sans-serif',
                                fontWeight: 400,
                                marginBottom: '8px',
                              }}
                            >
                              {dao.name}
                            </Typography>
                            <Typography
                              sx={{
                                color: '#9DA3AF',
                                fontSize: '14px',
                                fontFamily: 'Questrial, sans-serif',
                                fontWeight: 400,
                              }}
                            >
                              {dao.code}
                            </Typography>
                          </CardContent>
                        </Card>
                      </Link>
                    </Col>
                  ))}
                </div>
              </Section>
            )}
          </div>
        </main>
        {this.props.footer}
      </div>
    );
  }
}

const mapStateToProps = ({}) => ({});

const mapDispatchToProps = {
  getLicenseByUser,
  getDAOList,
};

export default connect(mapStateToProps, mapDispatchToProps)(DaoInfo);
